module.exports = __webpack_public_path__ + "static/img/logo.47158c2.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo.svg
// module id = zxL1
// module chunks = 1